function MediaLoadError(message) {
  this.name = 'Could Not Load Media';
  this.message = message || 'Unable to load media';

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

MediaLoadError.prototype = Object.create(Error.prototype);
MediaLoadError.prototype.constructor = MediaLoadError;

export default MediaLoadError;
